<template>
  <div>
    <van-dialog v-model="dialogFormVisible" title="确定删除设备？" show-cancel-button :beforeClose="handleClose">

    </van-dialog>
  </div>
</template>

<script>

  export default {
    name: 'DevUnbind',
    props: [
      "did"
    ],
    data() {
      return {
        dialogFormVisible: true,
      };
    },
    methods: {
      handleClose(action, done) {
        if (action === 'confirm') {
          done(false);
          this.unbind(this.did);
        } else if (action === 'cancel') {
          this.$emit('configstatus', false);
          done(); //关闭
        }
      },
      unbind(did) {
        const qs = require('qs');
        this.$axios.post('/api/dev/unbind', qs.stringify({ 'did': did }))
          .then((response) => {
            if (response.data.error_code === 0) {
              this.$emit('configstatus', true);
            }
            else if (response.data.error_code === 301) {
              this.$router.push({ path: '/login', name: 'login' })
            }

          })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import "../../assets/hkapp.css";
</style>